import { RootStore } from 'stores/pet-profile-new/types';
import { getCustomerKey } from 'stores/pet-profile-new/utils/get-customer-key';
import { PetProfile } from 'types/pet-profile';

export const getCustomerPets = (state: RootStore): PetProfile[] => {
  const { customerId, petProfiles } = state;
  const customerKey = getCustomerKey(customerId);
  const customerPetProfilesIds = state.profilesPerCustomer[customerKey];
  return petProfiles.filter((profile) => customerPetProfilesIds.includes(profile.id));
};
